<template>
  <div class="w-full text-center border-t mt-2">
    <div class="mt-2 mb-4 text-xs">Copyright © East Japan Railway Company All Rights Reserved.</div>
  </div>
</template>

<script>
export default {
  methods: {
    top: function () {
      window.location.href = 'https://www.jreast.co.jp/';
    }
  }
}
</script>
